export default __webpack_public_path__ + "static/media/thumbnail_blog_9.fde243b6.png";